import { instanceServerTest, instanceServerProd, instanceServer } from './request';
import { getSession } from './ulti';

export const updateHeaders = (headers) => {
  restoreExistingHeaders();


  Object.keys(headers).forEach(key => {
    instanceServer.defaults.headers.common[key] = headers[key];
  });

  console.log('updateHeaders', headers);
  console.log('instanceServerTest header', instanceServer.defaults.headers);
}

export const removeHeaders = (headers) => {
  restoreExistingHeaders();

  console.log('instanceServerTest header', instanceServer.defaults.headers);
  console.log('remove', headers);

  headers.forEach(key => {
    delete instanceServer.defaults.headers.common[key];
  });

  console.log('instanceServerTest header after removal', instanceServer.defaults.headers);
}

export const restoreExistingHeaders = () => {
  const headers = {
    'LEGALLINK-USER': sessionStorage.getItem('legal_link_uid'),
    'LEGALLINK-SESSION': sessionStorage.getItem('legal_link_session'),
  }
  Object.keys(headers).forEach(key => {
    instanceServer.defaults.headers.common[key] = headers[key];
  });
}

/**
 * @returns {Promise<axios.AxiosResponse<StartChatResponse>>}
 */
export const startChat = () => {
  console.log('[DEBUG] >> start');
  return instanceServer.post('/appointment_assistant/user/message/start');
}

/**
 * 搜索
 * @param data {string}
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const sendMessage = (data = {}) => {
  console.log('[DEBUG] >> user message', data);
  const sendData = {
    'UserMessage': data,
    'SendTime': Date.now(),
  }
  return instanceServer.post('/appointment_assistant/user/message/send', sendData);
}

/**
 * @returns {Promise<axios.AxiosResponse<SendMessageResponse>>}
 */
export const getResponse = () => {
  console.log('[DEBUG] >> getting response.');
  return instanceServer.post('/appointment_assistant/user/message/receive');
}

/**
 * @param {BookingData} data
 * @returns {Promise<axios.AxiosResponse<AppointmentSummary>>}
 */
export const submitBooking = (data) => {
  return instanceServer.post('/appointment_assistant/user/card/appointment', data);
}

/**
 * @returns {Promise<axios.AxiosResponse<HistoryResponse>>}
 * Success when RetCode: 0
 * When the session is expired or invalid, the server will return 403 Forbidden error with 200008 RetCode and ErrorMessage:
 * ```json
 * {
 *     "RetCode": 200008,
 *     "ErrorMessage": "2024-03-05 15:39:37.900: [200008]Token认证不通过\n"
 * }
 * ```
 */
export const getHistory = () => {
    return instanceServer.post('/appointment_assistant/user/message/history');
}

/**
 * @param params {TrackLogData}
 * @param [customHeaders] {TrackLogData}
 * @returns {Promise<any>}
 */
export function postTrackLog(params, customHeaders) {
  console.log('DEBUG >> postTrackLog params:', params);
  return instanceServer.post('/tracker/front_end/log/create', params);
}
